import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { ReactiveAsteriskModule } from 'src/components/reactive-asterisk/reactive-asterisk.module'
import { SelectSearchModule } from 'src/components/select-search/select-search.module'
import { BulkActionDialogModule } from 'src/shared/bulk-action-dialog'
import { CheckCreditDialogModule } from '../check-credit-dialog/check-credit-dialog.module'
import { SendConfirmationHeaderComponent } from './send-confirmation-header.component'
import { SendConfirmationFormComponent } from './send-confirmation-form.component'
import { SendConfirmationFormService } from './send-confirmation-form.service'

@NgModule({
  declarations: [SendConfirmationFormComponent, SendConfirmationHeaderComponent],
  providers: [SendConfirmationFormService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    ReactiveAsteriskModule,
    SelectSearchModule,
    BulkActionDialogModule,
    CheckCreditDialogModule,
  ],
})
export class SendConfirmationFormModule { }
